// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3qbZ8","title":"Images45_title__30IhK","images":"Images45_images__3atZ-"};